import { AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from './Analytics.ts';
export function sendItemInfoSubscribeClickedAnalytic(itemName, itemType) {
    const eventData = {
        type: AnalyticEventType.ItemInfoSubscribeClicked,
        category: AnalyticEventCategory.Store,
        stringValue: itemName,
        dimensions: {
            itemType: itemType
        }
    };
    void CA.sendAnalyticEvent(eventData);
}
